<template>
  <!--
    Use this component as a wrapper to set a maximum width and auto margins to create side white space on wider browsers.
    Some resources such as maps will utilize the full width of the page no matter how wide the browser, and thus do not need this wrapper.
    However, others are relatively narrow and stretching the text or other contents all the way across the screen would not be desired.
  -->
  <div class="side-margins-wrapper">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'SideMarginsWrapper',

  props: {
    maxWidth: { type: String, required: false },
    sidePaddingRem: { type: String, required: false }
  },

  mounted () {
    let wrappers = document.getElementsByClassName('side-margins-wrapper')

    if (this.maxWidth) {
      for (let i=0; i < wrappers.length; i++) {
        wrappers[i].style.maxWidth = this.maxWidth + 'px'
      }
    }

    if (this.sidePaddingRem) {
      for (let i=0; i < wrappers.length; i++) {
        wrappers[i].style.paddingLeft = this.sidePaddingRem + 'rem'
        wrappers[i].style.paddingRight = this.sidePaddingRem + 'rem'
      }
    }
  }
}
</script>

<style lang="scss">
.side-margins-wrapper {
  max-width: 1800px;
  margin: 0 auto;
}
</style>